import { ButtonRadioGroupField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { ESuburbanWCType } from '../../../../json_query';
import { changeSuburbanWCType } from '../../../state/advanced/suburban_wc';
import { InlineParam, Row } from '../markup';

interface ISuburbanWCProps {
  wc_type: ESuburbanWCType;
  onSuburbanWCTypeChanged(wcType: ESuburbanWCType): void;
}

const getChangedSuburbanWCType = (value: string): ESuburbanWCType => {
  if (value === 'Inside') {
    return ESuburbanWCType.Inside;
  } else if (value === 'Outside') {
    return ESuburbanWCType.Outside;
  } else {
    return ESuburbanWCType.Any;
  }
};

const SuburbanWC: React.StatelessComponent<ISuburbanWCProps> = props => {
  let radioGroupValue = '';
  if (props.wc_type === ESuburbanWCType.Inside) {
    radioGroupValue = 'Inside';
  }
  if (props.wc_type === ESuburbanWCType.Outside) {
    radioGroupValue = 'Outside';
  }

  return (
    <Row title="Санузел">
      <InlineParam>
        <ButtonRadioGroupField
          uncheckable
          value={radioGroupValue}
          onValueChange={value => props.onSuburbanWCTypeChanged(getChangedSuburbanWCType(value))}
          values={[
            { value: 'Inside', label: 'В доме' },
            { value: 'Outside', label: 'На улице' },
          ]}
        />
      </InlineParam>
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => {
    const jq = state.filters.jsonQuery;

    return {
      wc_type: (jq.wc_site && jq.wc_site.value) || ESuburbanWCType.Any,
    };
  },
  (dispatch: Dispatch) => ({
    onSuburbanWCTypeChanged: (wcType: ESuburbanWCType) => {
      dispatch(changeSuburbanWCType(wcType));
    },
  }),
)(SuburbanWC);
